(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2132],{

/***/ 17001:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Heading; }
});

// EXTERNAL MODULE: ./functions/createMarkup.js
var createMarkup = __webpack_require__(4089);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./components/atoms/Heading/Heading.js



/**
 * Render the Heading component.
 *
 * @param  {object}  props           The props object.
 * @param  {string}  props.children  The elements or text you'd like to render inside the heading.
 * @param  {string}  props.className The optional classname.
 * @param  {string}  props.id        The optional ID.
 * @param  {object}  props.style     The style attributes.
 * @param  {string}  props.tag       The tag name you'd like the heading to render as.
 * @return {Element}                 The Heading element.
 */ function Heading(param) {
    var children = param.children, className = param.className, id = param.id, style = param.style, tag = param.tag;
    if (typeof children === 'string') {
        return(/*#__PURE__*/ react.createElement(tag, {
            className: className,
            id: id,
            style: style,
            dangerouslySetInnerHTML: (0,createMarkup/* default */.Z)(children)
        }));
    } else {
        return(/*#__PURE__*/ react.createElement(tag, {
            className: className,
            id: id,
            style: style
        }, children));
    }
};
Heading.propTypes = {
    children: prop_types_default().oneOfType([
        (prop_types_default()).node,
        (prop_types_default()).string
    ]),
    className: (prop_types_default()).string,
    id: (prop_types_default()).string,
    style: (prop_types_default()).object,
    tag: prop_types_default().oneOf([
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6'
    ])
};
Heading.defaultProps = {
    tag: 'h1'
};

;// CONCATENATED MODULE: ./components/atoms/Heading/index.js



/***/ }),

/***/ 10882:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ Archive; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./components/atoms/Button/index.js + 4 modules
var Button = __webpack_require__(5536);
// EXTERNAL MODULE: ./components/atoms/Heading/index.js + 1 modules
var Heading = __webpack_require__(17001);
// EXTERNAL MODULE: ./components/atoms/RichText/index.js + 1 modules
var RichText = __webpack_require__(36091);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(94184);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/molecules/Card/Card.module.css
var Card_module = __webpack_require__(28565);
var Card_module_default = /*#__PURE__*/__webpack_require__.n(Card_module);
;// CONCATENATED MODULE: ./components/molecules/Card/Card.js









/**
 * Render the Card component.
 *
 * @param  {object}  props              Card component props.
 * @param  {string}  props.body         Card body text.
 * @param  {string}  props.buttonText   The text for the cta button.
 * @param  {string}  props.className    Optional classNames.
 * @param  {string}  props.headingLevel The heading tag.
 * @param  {object}  props.image        The image object.
 * @param  {string}  props.meta         The card metadata string.
 * @param  {string}  props.timestamp    The card timestamp.
 * @param  {string}  props.title        The card title.
 * @param  {string}  props.url          The url.
 * @return {Element}                    The Card component.
 */ function Card(param) {
    var body = param.body, buttonText = param.buttonText, className = param.className, headingLevel = param.headingLevel, image = param.image, meta = param.meta, timestamp = param.timestamp, title = param.title, url = param.url;
    var _altText;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((Card_module_default()).card, className),
        children: [
            image && image.sourceUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Card_module_default()).image,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                    draggable: "false",
                    src: image.sourceUrl,
                    alt: "".concat((_altText = image.altText) !== null && _altText !== void 0 ? _altText : title),
                    loading: "lazy",
                    height: image.height,
                    width: image.width
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Card_module_default()).content,
                children: [
                    meta && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (Card_module_default()).meta,
                        children: meta
                    }),
                    title && (url ? /*#__PURE__*/ (0,jsx_runtime.jsx)(next_link["default"], {
                        href: url,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                                className: (Card_module_default()).title,
                                tag: headingLevel,
                                children: title
                            })
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading/* default */.Z, {
                        className: (Card_module_default()).title,
                        children: title
                    })),
                    body && /*#__PURE__*/ (0,jsx_runtime.jsx)(RichText/* default */.Z, {
                        className: (Card_module_default()).body,
                        children: body
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Card_module_default()).footer,
                children: [
                    timestamp && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (Card_module_default()).timestamp,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("time", {
                            children: timestamp
                        })
                    }),
                    buttonText && url && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                        className: (Card_module_default()).button,
                        url: url,
                        text: buttonText,
                        type: "secondary",
                        size: "md"
                    })
                ]
            })
        ]
    }));
};
Card.propTypes = {
    body: (prop_types_default()).string,
    buttonText: (prop_types_default()).string,
    className: (prop_types_default()).string,
    headingLevel: prop_types_default().oneOf([
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6'
    ]),
    image: prop_types_default().shape({
        sourceUrl: (prop_types_default()).string,
        altText: (prop_types_default()).string,
        height: (prop_types_default()).string,
        width: (prop_types_default()).string
    }),
    meta: (prop_types_default()).string,
    title: (prop_types_default()).string,
    timestamp: (prop_types_default()).string,
    url: (prop_types_default()).string
};
Card.defaultProps = {
    headingLevel: 'h2'
};

;// CONCATENATED MODULE: ./components/molecules/Card/index.js


// EXTERNAL MODULE: ./functions/getPagePropTypes.js + 5 modules
var getPagePropTypes = __webpack_require__(23684);
// EXTERNAL MODULE: ./lib/next-api/connector.js + 2 modules
var connector = __webpack_require__(90848);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(17283);
;// CONCATENATED MODULE: ./lib/next-api/wordpress/archive/queryArchivePosts.js


function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  query GET_ARCHIVE_POSTS(\n    $postType: String!\n    $cursor: String!\n    $year: Int\n    $month: Int\n    $day: Int\n    $taxonomy: String\n    $term: ID\n    $orderBy: String = DATE\n    $order: String = DESC\n  ) {\n    archive(\n      postType: $postType\n      cursor: $cursor\n      year: $year\n      month: $month\n      day: $day\n      taxonomy: $taxonomy\n      term: $term\n      orderBy: $orderBy\n      order: $order\n    ) @rest(type: \"Archive\", path: \"",
        "?{args}\") {\n      pagination\n      posts\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
// Query: retrieve archive posts by post type.
var queryArchivePosts = (0,lib/* gql */.Ps)(_templateObject(), connector/* nextApiRoutes.wordpress.archive */.PO.wordpress.archive);
/* harmony default export */ var archive_queryArchivePosts = (queryArchivePosts);

;// CONCATENATED MODULE: ./functions/next-api/wordpress/archive/getArchivePosts.js



function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
/**
 * Retrieve next page of posts for post type archive.
 *
 * @author WebDevStudios
 * @param  {string} postType     WP post type.
 * @param  {string} cursor       Start cursor for pagination.
 * @param  {object} date         Optional date query props.
 * @param  {string} date.day     Date query: day.
 * @param  {string} date.month   Date query: month.
 * @param  {string} date.year    Date query: year.
 * @param  {object} tax          Optional taxonomy query props.
 * @param  {string} tax.taxonomy Tax query: taxonomy.
 * @param  {string} tax.term     Tax query: term.
 * @param  {string} orderBy      Order by: field.
 * @param  {string} order        Order by: direction.
 * @return {object}              Archive post and pagination data or error object.
 */ function getArchivePosts(postType) {
    return _getArchivePosts.apply(this, arguments);
};
function _getArchivePosts() {
    _getArchivePosts = _asyncToGenerator(runtime_default().mark(function _callee(postType) {
        var cursor, date, tax, orderBy, order, day, month, year, taxonomy, term, apolloClient, ref, _args = arguments;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    cursor = _args.length > 1 && _args[1] !== void 0 ? _args[1] : null, date = _args.length > 2 && _args[2] !== void 0 ? _args[2] : {}, tax = _args.length > 3 && _args[3] !== void 0 ? _args[3] : {}, orderBy = _args.length > 4 && _args[4] !== void 0 ? _args[4] : 'DATE', order = _args.length > 5 && _args[5] !== void 0 ? _args[5] : 'DESC';
                    day = date.day, month = date.month, year = date.year;
                    taxonomy = tax.taxonomy, term = tax.term;
                    apolloClient = (0,connector/* initializeNextApiApollo */.nr)();
                    ;
                    return _ctx.abrupt("return", apolloClient.query({
                        query: archive_queryArchivePosts,
                        variables: {
                            postType: postType,
                            cursor: cursor,
                            orderBy: orderBy,
                            order: order,
                            day: day,
                            month: month,
                            year: year,
                            taxonomy: taxonomy,
                            term: term
                        }
                    }).then(function(response) {
                        var ref1;
                        return (ref = response === null || response === void 0 ? void 0 : (ref1 = response.data) === null || ref1 === void 0 ? void 0 : ref1.archive) !== null && ref !== void 0 ? ref : {
                            error: true,
                            errorMessage: "An error occurred while trying to retrieve data for ".concat(postType, " archive.")
                        };
                    }).catch(function(error) {
                        return {
                            error: true,
                            errorMessage: error.message
                        };
                    }));
                case 6:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _getArchivePosts.apply(this, arguments);
}

;// CONCATENATED MODULE: ./components/organisms/Archive/Archive.js








function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function Archive_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function Archive_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                Archive_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                Archive_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
/**
 * Render the Archive component.
 *
 * @author WebDevStudios
 * @param  {object}  props            The component attributes as props.
 * @param  {object}  props.date       Optional date query props.
 * @param  {string}  props.date.day   Date query: day.
 * @param  {string}  props.date.month Date query: month.
 * @param  {string}  props.date.year  Date query: year.
 * @param  {object}  props.pagination Archive pagination data from WordPress.
 * @param  {Array}   props.posts      Array of post data from WordPress.
 * @param  {string}  props.postType   WP post type.
 * @param  {string}  props.taxonomy   WP taxonomy type slug.
 * @param  {string}  props.term       The manually-selected term.
 * @return {Element}                  The Archive component.
 */ function Archive(param) {
    var tmp = param.date, ref5 = tmp === void 0 ? {} : tmp, day = ref5.day, month = ref5.month, year = ref5.year, posts = param.posts, pagination = param.pagination, postType = param.postType, taxonomy = param.taxonomy, term = param.term;
    var ref1;
    // Track all posts, including initial posts and additionally loaded pages.
    var ref2 = (0,react.useState)(posts), allPosts = ref2[0], setAllPosts = ref2[1];
    // Track "load more" button state.
    var ref3 = (0,react.useState)(false), loadingMore = ref3[0], setLoadingMore = ref3[1];
    // Track current pagination object.
    var paginationRef = (0,react.useRef)(pagination);
    function loadPosts() {
        return _loadPosts.apply(this, arguments);
    }
    function _loadPosts() {
        _loadPosts = /**
   * Load more posts for archive.
   */ Archive_asyncToGenerator(runtime_default().mark(function _callee() {
            var ref, newPosts, ref4;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        setLoadingMore(true);
                        _ctx.next = 4;
                        return getArchivePosts(postType, (ref = paginationRef.current) === null || ref === void 0 ? void 0 : ref.endCursor, {
                            day: day,
                            month: month,
                            year: year
                        }, {
                            taxonomy: taxonomy,
                            term: term
                        });
                    case 4:
                        newPosts = _ctx.sent;
                        ;
                        setAllPosts(_toConsumableArray(allPosts).concat(_toConsumableArray((ref4 = newPosts === null || newPosts === void 0 ? void 0 : newPosts.posts) !== null && ref4 !== void 0 ? ref4 : [])));
                        // Update pagination ref.
                        paginationRef.current = newPosts === null || newPosts === void 0 ? void 0 : newPosts.pagination;
                        setLoadingMore(false);
                    case 9:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return _loadPosts.apply(this, arguments);
    }
    if (!allPosts || !allPosts.length) {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
            children: "No posts found."
        }));
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "grid lg:grid-cols-2 gap-12",
                children: allPosts.map(function(post, index) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(Card, {
                        title: post === null || post === void 0 ? void 0 : post.title,
                        url: post === null || post === void 0 ? void 0 : post.uri,
                        body: post === null || post === void 0 ? void 0 : post.excerpt
                    }, index);
                })
            }),
            ((ref1 = paginationRef.current) === null || ref1 === void 0 ? void 0 : ref1.hasNextPage) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                onClick: loadPosts,
                text: loadingMore ? 'Loading...' : 'Load More',
                type: "secondary",
                disabled: loadingMore
            })
        ]
    }));
};
Archive.propTypes = _objectSpread({}, getPagePropTypes/* archivePropTypes */.te, {
    date: prop_types.PropTypes.shape({
        day: prop_types.PropTypes.string,
        month: prop_types.PropTypes.string,
        year: prop_types.PropTypes.string
    }),
    taxonomy: prop_types.PropTypes.string,
    term: prop_types.PropTypes.string
});

;// CONCATENATED MODULE: ./components/organisms/Archive/index.js



/***/ }),

/***/ 90848:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "nr": function() { return /* binding */ initializeNextApiApollo; },
  "PO": function() { return /* binding */ nextApiRoutes; }
});

// UNUSED EXPORTS: createNextApiApolloClient

;// CONCATENATED MODULE: ./functions/wordpress/gravityForms/encodeGfFormData.js
/**
 * Encode GF form data into multipart form data.
 *
 * @param  {object} data GF form data.
 * @return {object}      Encoded form data.
 */ function encodeGfFormData(data) {
    var formData = new FormData();
    formData.append('formId', data === null || data === void 0 ? void 0 : data.formId);
    if (!(data === null || data === void 0 ? void 0 : data.fieldValues) || !(data === null || data === void 0 ? void 0 : data.fieldValues.length)) {
        return {
            body: formData
        };
    }
    data.fieldValues.forEach(function(field) {
        // Check if field is file upload field.
        if (field === null || field === void 0 ? void 0 : field.fileUploadValues) {
            // Pass uploaded file data.
            formData.append("field_".concat(field.id), field.fileUploadValues);
        } else {
            // Pass stringified version of full field object for all other field types.
            formData.append("field_".concat(field.id), JSON.stringify(field));
        }
    });
    return {
        body: formData
    };
};

// EXTERNAL MODULE: ./lib/apolloConfig.js
var apolloConfig = __webpack_require__(91467);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 10 modules
var lib = __webpack_require__(17283);
;// CONCATENATED MODULE: ./lib/next-api/wordpress/_config/schema.js

function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  scalar Upload\n\n  type AddressInput {\n    street: String\n    lineTwo: String\n    city: String\n    state: String\n    zip: String\n    country: String\n  }\n\n  type ChainedSelectInput {\n    inputId: Float\n    value: String\n  }\n\n  type CheckboxInput {\n    inputId: Float\n    value: String\n  }\n\n  type ListInput {\n    values: [String]\n    rowValues: [String]\n  }\n\n  type NameInput {\n    prefix: String\n    first: String\n    middle: String\n    last: String\n    suffix: String\n  }\n\n  type Upload {\n    name: String\n    type: String\n    size: Int\n    tmp_name: String\n  }\n\n  type FieldValuesInput {\n    id: Int!\n    addressValues: AddressInput\n    chainedSelectValues: [ChainedSelectInput]\n    checkboxValues: [CheckboxInput]\n    fileUploadValues: Upload\n    listValues: [ListInput]\n    nameValues: NameInput\n    values: [String]\n    value: String\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
// Define WP Next.js API GraphQL schema.
var typeDefs = (0,lib/* gql */.Ps)(_templateObject());

// EXTERNAL MODULE: ./node_modules/@apollo/client/core/ApolloClient.js + 4 modules
var ApolloClient = __webpack_require__(16615);
// EXTERNAL MODULE: ./node_modules/@apollo/client/cache/inmemory/inMemoryCache.js + 5 modules
var inMemoryCache = __webpack_require__(32393);
// EXTERNAL MODULE: ./node_modules/apollo-link-rest/bundle.umd.js
var bundle_umd = __webpack_require__(20054);
;// CONCATENATED MODULE: ./lib/next-api/connector.js





var nextApiApolloClient;
// Define API route bases.
var nextApiRouteBases = {
    wordpress: '/wordpress'
};
// Define API routes.
var nextApiRoutes = {
    wordpress: {
        archive: "".concat(nextApiRouteBases.wordpress, "/archive"),
        comments: "".concat(nextApiRouteBases.wordpress, "/comments"),
        gravityForms: "".concat(nextApiRouteBases.wordpress, "/gravityForms")
    }
};
// Define Next.js API route link.
var restLink = new bundle_umd.RestLink({
    uri: '/api',
    bodySerializers: {
        encodeGfFormData: encodeGfFormData
    }
});
/**
 * Create a basic Apollo client for connecting to Next.js API Routes.
 *
 * @see https://www.apollographql.com/docs/react/api/core/ApolloClient/
 * @author WebDevStudios
 * @return {object} Apollo client instance.
 */ function createNextApiApolloClient() {
    return new ApolloClient/* ApolloClient */.f({
        ssrMode: false,
        link: restLink,
        cache: new inMemoryCache/* InMemoryCache */.h(),
        // TODO: figure out how to combine multiple type defs (i.e., WP and other APIs) and pass as single prop here.
        typeDefs: typeDefs
    });
}
/**
 * Init Apollo for Next.js API and merge with initial state.
 *
 * @author WebDevStudios
 * @param  {*}      initialState Initial Apollo state.
 * @return {object}              Next.js API Apollo client instance.
 */ function initializeNextApiApollo() {
    var initialState = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null;
    // Only run one instance of the Apollo client.
    var _apolloClient = nextApiApolloClient !== null && nextApiApolloClient !== void 0 ? nextApiApolloClient : createNextApiApolloClient();
    var newApolloClient = (0,apolloConfig/* initializeApollo */["in"])(_apolloClient, initialState);
    // For SSG and SSR always create a new Apollo Client.
    if (false) {}
    // Create the Apollo Client once in the client.
    if (!nextApiApolloClient) nextApiApolloClient = newApolloClient;
    return newApolloClient;
}


/***/ }),

/***/ 28565:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"card":"Card_card__tX2Ix","image":"Card_image__edrIj","content":"Card_content__HMpqQ","meta":"Card_meta__PvgBe","title":"Card_title__IijWS","body":"Card_body__eda2c","footer":"Card_footer__x7j5N","timestamp":"Card_timestamp__UAog8"};

/***/ }),

/***/ 24654:
/***/ (function() {

/* (ignored) */

/***/ })

}]);